<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('jobs')">
            <app-default-button
                :title="$fieldTitle('add', 'job', true)"
                v-if="$can('create_work_place')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="work-place-table"
            :options="options"
            @action="triggerActions"
        />

        <app-work-place-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-work-place-translate
            v-if="isTranslateModalActive"
            v-model="isTranslateModalActive"
            :work-place-id="workPlaceId"
            @close="isTranslateModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('work-place-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import WorkPlaceMixins from "../../../Mixins/WorkPlaceMixins";
import {urlGenerator, axiosPost} from "../../../../../common/Helper/AxiosHelper";
import AppWorkPlaceTranslate from "./WorkPlaceTranslate";

export default {
    name  : "AppWorkPlace",
    components: {AppWorkPlaceTranslate},
    mixins: [HelperMixin, WorkPlaceMixins],
    props : {
        employeeId: {
            type: String,
        },
    },
    data() {
        return {
            isModalActive: false,
            isTranslateModalActive: false,
            selectedUrl  : '',
            workPlaceId: null,
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/work-place/${row.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('translate')) {
                this.workPlaceId = row.id;
                this.isTranslateModalActive = true;
            } else if (action.title === this.$t('copy')) {
                axiosPost(
                    `${TENANT_BASE_URL}app/short-link`,
                    {
                        work_place_id: row.id,
                        eid: this.employeeId
                    }
                ).then(({data}) => {
                    this.$copyToClipboard(data.short_url)
                        .then(() => {
                            this.$toastr.s(this.$t('Copy success!'))
                        })
                        .catch(() => {
                            this.$toastr.e(this.$t('Copy failed!'))
                        })
                }).catch((error) => {
                    this.$toastr.e(error.response.data.message || this.$t('Copy failed!'))
                })
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>